import React from 'react';
import CheckCard from './pages/CheckCard';
import ViewCard from './pages/ViewCard';
import UploadCardContent from './pages/UploadCardContent';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import CardNotExist from './pages/CardNotExist';
import Home from './pages/Home';
import Terms from './pages/Terms';

function App() {
  return (
    <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home" element={<Home />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/card_uid/:card_uid/" element={<CheckCard />} />
        <Route path="/video/:card_uid/" element={<ViewCard />} />
        <Route path="/upload/:card_uid/" element={<UploadCardContent />} />
   {/* Add other valid routes above... */}

        {/* 404 / Catch-all route */}
        <Route path="*" element={<CardNotExist />} />
        </Routes>
  );
}

export default App;
